import { SupplierItem } from './types';

export const data: SupplierItem[] = [
  {
    id: 0,
    vendor: 'וולט',
    date: '2024-02-01T00:00:00.000Z',
    amount: 72,
    category: 'קניות',
  },
  {
    id: 1,
    vendor: 'וולט',
    date: '2024-02-01T00:00:00.000Z',
    amount: 72,
    category: 'קניות',
  },
  {
    id: 2,
    vendor: 'וולט',
    date: '2024-02-01T00:00:00.000Z',
    amount: 72,
    category: 'קניות',
  },
  {
    id: 3,
    vendor: 'וולט',
    date: '2024-02-01T00:00:00.000Z',
    amount: 72,
    category: 'קניות',
  },
  {
    id: 4,
    vendor: 'וולט',
    date: '2024-02-01T00:00:00.000Z',
    amount: 72,
    category: 'קניות',
  },
];
